import { ExternalLink } from "@dolthub/react-components";
import { IoLogoRss } from "@react-icons/all-files/io/IoLogoRss";
import cx from "classnames";
import React from "react";
import {
  FacebookIcon,
  FacebookShareButton,
  LinkedinIcon,
  LinkedinShareButton,
  TwitterIcon,
  TwitterShareButton,
} from "react-share";
import * as css from "./ShareWidget.module.css";

export default function ShareWidget(props: {
  className?: string;
  url: string;
}) {
  const iconProps = {
    size: 40,
    iconFillColor: "#010a40",
    bgStyle: { fill: "transparent" },
  };
  return (
    <div
      className={cx(css.shareWidget, props.className)}
      data-cy="blog-share-widget"
    >
      <p>SHARE</p>
      <div>
        <FacebookShareButton url={props.url}>
          <FacebookIcon {...iconProps} />
        </FacebookShareButton>
        <LinkedinShareButton url={props.url}>
          <LinkedinIcon {...iconProps} />
        </LinkedinShareButton>
        <TwitterShareButton url={props.url}>
          <TwitterIcon {...iconProps} />
        </TwitterShareButton>
        <ExternalLink href="https://www.dolthub.com/blog/rss.xml">
          <div className={css.rssContainer}>
            <IoLogoRss className={css.rssIcon} />
          </div>
        </ExternalLink>
      </div>
    </div>
  );
}
